module.exports = __webpack_public_path__ + "static/media/step-3.11b3db9b.png";